(() => {
  /*
   * Prevent the script being initialised more than once.
   */
  if (window.collectionCardSwatchesInitialised) {
    return;
  }

  window.collectionCardSwatchesInitialised = true;

  /*
   * Use event delegation because Shopify replaces the collection grid
   * when customers filter, sort or paginate products.
   */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-collection-swatch]');

    if (!swatch) {
      return;
    }

    /*
     * Stop Dawn's stretched product-card link from opening the product
     * when the customer clicks a swatch.
     */
    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.card-wrapper');

    if (!card) {
      return;
    }

    const primaryImage = card.querySelector('[data-card-primary-image]');
    const imageSrc = swatch.dataset.imageSrc;
    const imageSrcset = swatch.dataset.imageSrcset;
    const imageAlt = swatch.dataset.imageAlt;
    const variantUrl = swatch.dataset.variantUrl;

    /*
     * Mark the clicked swatch as selected.
     */
    card.querySelectorAll('[data-collection-swatch]').forEach((button) => {
      button.setAttribute(
        'aria-pressed',
        button === swatch ? 'true' : 'false'
      );
    });

    /*
     * Change the large collection-card image.
     */
    if (primaryImage && imageSrc) {
      primaryImage.src = imageSrc;

      if (imageSrcset) {
        primaryImage.srcset = imageSrcset.trim();
      } else {
        primaryImage.removeAttribute('srcset');
      }

      if (imageAlt) {
        primaryImage.alt = imageAlt;
      }
    }

    /*
     * Update the product title/card links so they open the selected colour.
     */
    if (variantUrl) {
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.href = variantUrl;
      });

      card
        .querySelectorAll('a.product__view-details')
        .forEach((link) => {
          link.href = variantUrl;
        });

      /*
       * Update Dawn's standard quick-add button.
       */
      card.querySelectorAll('[data-product-url]').forEach((element) => {
        element.dataset.productUrl = variantUrl;
      });

      /*
       * Update Dawn's bulk quick-add modal.
       */
      card.querySelectorAll('bulk-modal[data-url]').forEach((element) => {
        element.dataset.url = variantUrl;
      });
    }
  });
})();